// extracted by mini-css-extract-plugin
export default {"manageGroupFooter":"ManageGroupFooter_manageGroupFooter__csu18","cancelText":"ManageGroupFooter_cancelText__d4yij"};